import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of, ReplaySubject, tap} from 'rxjs';
import {Navigation} from 'app/core/navigation/navigation.types';
import {UserService} from "../user/user.service";

@Injectable({
    providedIn: 'root'
})
export class NavigationService {
    private _navigation: ReplaySubject<any> = new ReplaySubject<any>(1);
    private defaultNavigation: any[] = [
        {
            type: 'divider',
            allowedRoles: '*'
        },
        {
            id: 'dashboard',
            title: 'Dashboard',
            type: 'basic',
            icon: 'mat_outline:dashboard',
            link: 'dashboard',
            allowedRoles: '*'
        },
        {
            type: 'divider',
            allowedRoles: '*'
        },
        {
            id: 'gestione-utenti',
            title: 'Gestione Utenti',
            subtitle: 'Gestisci gli utenti interni',
            type: 'group',
            icon: 'heroicons_outline:users',
            allowedRoles: ['amministratore'],
            children: [
                {
                    id: 'gestione-utenti.add',
                    title: 'Nuovo utente',
                    type: 'basic',
                    icon: 'mat_outline:person_add_alt',
                    link: '/manage-users/create'
                },
                {
                    id: 'gestione-utenti.list',
                    title: 'Lista utenti',
                    type: 'basic',
                    icon: 'mat_outline:people_alt',
                    link: '/manage-users/list'
                },
            ]
        },
        {
            type: 'divider',
            allowedRoles: ['amministratore'],
        },
        {
            id: 'gestione-clienti',
            title: 'Gestione Clienti',
            subtitle: 'Gestisci i clienti',
            type: 'group',
            icon: 'heroicons_outline:users',
            allowedRoles: ['amministratore', 'ufficio'],
            children: [
                {
                    id: 'gestione-clienti.add',
                    title: 'Nuovo cliente',
                    type: 'basic',
                    icon: 'mat_outline:add_business',
                    link: '/customers/create'
                },
                {
                    id: 'gestione-clienti.list',
                    title: 'Lista clienti',
                    type: 'basic',
                    icon: 'mat_outline:maps_home_work',
                    link: '/customers/list'
                },
                {
                    id: 'gestione-clienti.list.so',
                    title: 'Sedi operative',
                    type: 'basic',
                    icon: 'mat_outline:room_preferences',
                    link: '/customers/sites'
                },
            ]
        },
        {
            type: 'divider',
            allowedRoles: ['amministratore', 'ufficio'],
        },
        {
            id: 'manutenzione',
            title: 'Manutenzioni',
            subtitle: 'Pianifica e gestisci le manutenzioni',
            type: 'group',
            icon: 'mat_outline:build',
            allowedRoles: ['amministratore', 'tecnico', 'dipendente', 'magazzino'],
            children: [
                {
                    id: 'manutenzione.pianifica',
                    title: 'Pianifica manutenzioni',
                    type: 'basic',
                    icon: 'mat_outline:edit_calendar',
                    link: '/maintenances/maintenance-planning'
                },
                {
                    id: 'manutenzione.calendario',
                    title: 'Calendario manutenzioni',
                    type: 'basic',
                    icon: 'heroicons_outline:calendar',
                    link: '/maintenances/maintenance-calendar'
                },
                {
                    id: 'manutenzione.manutenzioni_avviate',
                    title: 'Manutenzioni in corso',
                    type: 'basic',
                    icon: 'mat_outline:build',
                    link: '/maintenances/maintenance-sessions'
                }
            ]
        },
        {
            type: 'divider',
            allowedRoles: ['amministratore', 'tecnico', 'dipendente', 'magazzino'],
        },
        {
            id: 'qrcode',
            title: 'QR CODE',
            subtitle: 'Genera e gestisci i QR CODE',
            type: 'group',
            icon: 'heroicons_outline:qrcode',
            allowedRoles: ['amministratore', 'tecnico', 'dipendente', 'magazzino'],
            children: [
                {
                    id: 'qrcode.scanner',
                    title: 'QR CODE scanner',
                    type: 'basic',
                    icon: 'mat_outline:qr_code_scanner',
                    link: '/qrcode/scanner'
                },
                {
                    id: 'qrcode.pages',
                    title: 'Pagine QR CODE',
                    type: 'basic',
                    icon: 'heroicons_outline:document',
                    link: '/qrcode/pages'
                }
            ]
        },
        {
            type: 'divider',
            allowedRoles: ['amministratore', 'tecnico', 'dipendente', 'magazzino'],
        },
        {
            id: 'magazzino',
            title: 'Magazzino',
            subtitle: 'Gestisci i prodotti del magazzino',
            type: 'group',
            icon: 'heroicons_outline:users',
            allowedRoles: ['amministratore', 'tecnico', 'dipendente', 'magazzino'],
            children: [
                {
                    id: 'magazzino.estintori',
                    title: 'Estintori',
                    type: 'basic',
                    icon: 'mat_outline:fire_extinguisher',
                    link: '/repository/list-by-category/1'
                },
                {
                    id: 'magazzino.impianti_idrici',
                    title: 'Idranti e naspi',
                    type: 'basic',
                    icon: 'mat_outline:local_fire_department',
                    link: '/repository/list-by-category/2'
                },
                {
                    id: 'magazzino.impianti_fumi',
                    title: 'Impianti Riv. Fumi/Evac',
                    type: 'basic',
                    icon: 'mat_outline:warning_amber',
                    link: '/repository/list-by-category/3'
                },
                {
                    id: 'magazzino.gruppi_di_pompaggio',
                    title: 'Gruppi di pompaggio',
                    type: 'basic',
                    icon: 'mat_outline:water_drop',
                    link: '/repository/list-by-category/105'
                },
                {
                    id: 'magazzino.porte_e_uscite',
                    title: 'Porte e Uscite',
                    type: 'basic',
                    icon: 'mat_outline:sensor_door',
                    link: '/repository/list-by-category/4'
                },
                {
                    id: 'magazzino.sicurezza',
                    title: 'Sicurezza',
                    type: 'basic',
                    icon: 'mat_outline:health_and_safety',
                    link: '/repository/list-by-category/5'
                },
                {
                    id: 'magazzino.altro',
                    title: 'Altro',
                    type: 'basic',
                    icon: 'mat_outline:indeterminate_check_box',
                    link: '/repository/list-by-category/1000'
                },
            ]
        },
        {
            type: 'divider',
            allowedRoles: ['amministratore', 'tecnico', 'dipendente', 'magazzino'],
        },

    ];

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient, private _userService: UserService) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation> {
        return this._navigation.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<any> {
        const userRole = this._userService.currentRoleName;
        const navigation = this.defaultNavigation.filter(n => {
            return n.allowedRoles !== '*' ? n.allowedRoles?.includes(userRole) : true;
        });

        // Simula una chiamata HTTP con i dati filtrati
        return of({default: navigation}).pipe(
            tap((navigationData) => {
                // Questo simula l'effetto collaterale della chiamata API
                this._navigation.next(navigationData);
            })
        );
    }
}
